import React from "react";

const AuthContext = React.createContext({ token: "" });

export default AuthContext;
